export enum AddReportButtonTheme {
  Header = `header`,
  Sidenav = `sidenav`,
  CollapsedSidenav = `collapsed-sidenav`,
}
